import apiRequest from './client';

export const listSupervisedBanks = () => apiRequest('/banks/supervisor/banks/');

export const listSubSupervisors = () => apiRequest('/sub-supervisors/');

export const createSubSupervisor = (data) =>
  apiRequest('/sub-supervisors/', { method: 'POST', body: data });

export const updateSubSupervisor = (id, data) =>
  apiRequest(`/sub-supervisors/${id}/`, { method: 'PATCH', body: data });

export const deleteSubSupervisor = (id) =>
  apiRequest(`/sub-supervisors/${id}/`, { method: 'DELETE' });

// Page Parametres de loterie (2026-09-16) — jamais de portee 'Tout' (pas le
// domaine d'un superviseur) : Groupe = un de SES groups (listSupervisorGroups),
// Banque = une de SES banks (listSupervisedBanks, deja existant plus haut).
export const listSupervisorGroups = () => apiRequest('/banks/supervisor/groups/');

export const listSupervisorProductConfigs = ({ tirage, group, bank } = {}) => {
  const params = new URLSearchParams();
  if (tirage) params.set('tirage', tirage);
  if (group) params.set('group', group);
  else if (bank) params.set('bank', bank);
  return apiRequest(`/supervisor/product-configs/?${params.toString()}`);
};

export const createSupervisorProductConfig = (data) =>
  apiRequest('/supervisor/product-configs/', { method: 'POST', body: data });

// Central > Voir Parametres (2026-09-17) — endpoint DEDIE, decouple expres de
// '/supervisor/product-configs/' (gate par 'Parametres de loterie', une
// permission d'EDITION) : bug trouve en test reel, un superviseur avec
// seulement "Voir Parametres" accorde prenait 403 en cherchant, car la page
// reutilisait a tort l'endpoint d'edition. Meme gate que les autres pages :
// 'Voir Parametres' (sv_menu_key) suffit desormais, rien d'autre requis.
export const fetchSupervisorSeeParameters = ({ tirage, group, bank } = {}) => {
  const params = new URLSearchParams();
  if (tirage) params.set('tirage', tirage);
  if (group) params.set('group', group);
  else if (bank) params.set('bank', bank);
  return apiRequest(`/supervisor/see-parameters/?${params.toString()}`);
};

export const updateSupervisorProductConfig = (id, data) =>
  apiRequest(`/supervisor/product-configs/${id}/`, { method: 'PATCH', body: data });

// Dashboard superviseur (2026-09-16) — memes indicateurs que le dashboard company,
// limites a SES banks (Supervisor.covered_bank_ids()).
export const fetchSupervisorDashboard = ({ date } = {}) =>
  apiRequest(`/dashboard/supervisor-overview/${date ? `?date=${encodeURIComponent(date)}` : ''}`);

// Numeros gagnants (lecture seule cote superviseur — la saisie reste une action
// company/superadmin) : meme numero que la company, mais fiches/gain scopes a SES
// banks. Gate par HasSupervisorModelPermission('winning_number').
export const fetchSupervisorWinningNumberSummary = ({ date }) =>
  apiRequest(`/tirages/winning-numbers/supervisor/summary/?date=${encodeURIComponent(date)}`);

// Limites par numero (NumberLimit) — SES groups/banks uniquement. Gate par
// HasSupervisorModelPermission('number_limit').
export const listSupervisorNumberLimits = ({ tirage, group, bank } = {}) => {
  const params = new URLSearchParams();
  if (tirage) params.set('tirage', tirage);
  if (group) params.set('group', group);
  else if (bank) params.set('bank', bank);
  return apiRequest(`/supervisor/number-limits/?${params.toString()}`);
};

export const createSupervisorNumberLimit = (data) =>
  apiRequest('/supervisor/number-limits/', { method: 'POST', body: data });

export const updateSupervisorNumberLimit = (id, data) =>
  apiRequest(`/supervisor/number-limits/${id}/`, { method: 'PATCH', body: data });

export const deleteSupervisorNumberLimit = (id) =>
  apiRequest(`/supervisor/number-limits/${id}/`, { method: 'DELETE' });

// Rapports (2026-09-16) — memes 5 rapports que la company, restreints a SES
// banks (Supervisor.covered_bank_ids()) — jamais de radio de portee
// (Tout/Groupe/Superviseur/Banque), deja son propre perimetre. Gates par
// HasSupervisorModelPermission('ticket').
const toQuery = (params) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `?${qs}` : '';
};

export const fetchSupervisorCumulDetaille = ({ dateFrom, dateTo, lotteryFrom, lotteryUp, perteGain, group, bank }) =>
  apiRequest(`/tickets/supervisor/cumul-detaille/${toQuery({
    date_from: dateFrom, date_to: dateTo, tirage_from: lotteryFrom, tirage_up: lotteryUp, perte_gain: perteGain,
    group, bank,
  })}`);

export const fetchSupervisorPrizedNumbers = ({ tirage, date, group, bank }) =>
  apiRequest(`/tickets/supervisor/prized-numbers/${toQuery({ tirage, date, group, bank })}`);

// display_mode 'supervisor' n'existe pas cote superviseur (il n'y en a qu'UN,
// lui-meme) — jamais propose dans l'UI, le backend retombe sur 'global' si
// jamais envoye quand meme.
export const fetchSupervisorAccumulatedSummary = ({
  dateFrom, dateTo, lotteryFrom, lotteryUp, documentType, displayMode, orderBy, group, bank,
}) =>
  apiRequest(`/tickets/supervisor/accumulated-summary/${toQuery({
    date_from: dateFrom, date_to: dateTo, tirage_from: lotteryFrom, tirage_up: lotteryUp,
    document_type: documentType, display_mode: displayMode, order_by: orderBy, group, bank,
  })}`);

// Tickets Vendus — memes rapport que la company (dynamise le meme jour),
// restreint a SES banks.
export const fetchSupervisorTicketsVendus = ({ date, tirageFrom, tirageUp, statut }) =>
  apiRequest(`/tickets/supervisor/tickets-vendus/${toQuery({
    date, tirage_from: tirageFrom, tirage_up: tirageUp, statut,
  })}`);

// Rapports restants (restaures + gates par menu, 2026-09-17) — memes 7
// rapports que la company, restreints a SES banks.
// group/bank optionnels et mutuellement exclusifs (bank gagne si les deux
// sont fournis, cf. _resolve_supervisor_scope) — vide = tout le perimetre.
export const fetchSupervisorWinningTickets = ({ date, tirage, group, bank } = {}) => {
  const params = new URLSearchParams();
  if (date) params.set('date', date);
  if (tirage) params.set('tirage', tirage);
  if (group) params.set('group', group);
  if (bank) params.set('bank', bank);
  return apiRequest(`/tickets/supervisor/winning-tickets/?${params.toString()}`);
};

export const fetchSupervisorSalesList = ({ tirage, date, group, bank }) =>
  apiRequest(`/tickets/supervisor/sales-list/${toQuery({ tirage, date, group, bank })}`);

export const fetchSupervisorTerminalReport = () => apiRequest('/banks/supervisor/terminal-report/');

export const fetchSupervisorBankReport = ({ withDetails = true } = {}) =>
  apiRequest(`/banks/supervisor/bank-report/${toQuery({ with_details: withDetails })}`);

export const fetchSupervisorTicketsAnnules = ({ dateFrom, dateTo, tirageFrom, tirageUp, group, bank }) =>
  apiRequest(`/tickets/supervisor/tickets-annules/${toQuery({
    date_from: dateFrom, date_to: dateTo, tirage_from: tirageFrom, tirage_up: tirageUp, group, bank,
  })}`);

export const fetchSupervisorResumeBanqueLottery = ({ bank, tirage, date }) =>
  apiRequest(`/tickets/supervisor/resume-banque-lottery/${toQuery({ bank, tirage, date })}`);

// Parametres > Banque (2026-09-17) — gestion des banks du superviseur
// (voir/modifier/supprimer selon SupervisorPermission, jamais de creation :
// un bank nait de l'approbation d'un device par le superadmin, meme regle
// que cote company). Backend : SupervisorBankViewSet, router 'supervisor/banks-manage'.
export const getSupervisorBank = (id) => apiRequest(`/supervisor/banks-manage/${id}/`);

export const updateSupervisorBank = (id, data) =>
  apiRequest(`/supervisor/banks-manage/${id}/`, { method: 'PATCH', body: data });

// Parametres > Act/Desactiver Ventes (Manuel) — meme filtre Group/Bank optionnel
// que les pages Central (mutuellement exclusif), jamais 'All' au sens company
// (deja son propre perimetre) : 'All' cote query veut dire "toutes SES banks".
export const fetchSupervisorBankStatusList = ({ filter, scope }) => {
  const params = new URLSearchParams({ filter });
  if (scope) params.set('scope', scope);
  return apiRequest(`/banks/supervisor/bulk-status/?${params.toString()}`);
};

export const bulkSupervisorBankStatus = ({ action, filter, scope }) =>
  apiRequest('/banks/supervisor/bulk-status/', { method: 'POST', body: { action, filter, scope } });

// Central > Fermer Vente (2026-09-17) — lecture seule : voit les loteries
// fermees de sa company (manuel + heure passee), ne peut pas fermer/rouvrir
// (TirageClosure 100% company-wide, decision explicite de ne pas y toucher).
export const fetchSupervisorClosedTirages = ({ date } = {}) =>
  apiRequest(`/tirages/supervisor/closed/${toQuery({ date })}`);

// Central > Suivi des ventes / Banques Connecte / Verifier le Ticket (2026-09-16) —
// equivalents scopes de pages/central/*, restreints a SES banks
// (Supervisor.covered_bank_ids()). Jamais de radio All/Group/Supervisor/Bank :
// des filtres `bank`/`group` optionnels et mutuellement exclusifs (vide = toutes
// ses banks) remplacent le filtre de portee — cf. tickets/views.py:_resolve_supervisor_scope.
export const fetchSupervisorSalesMonitoringSummary = ({ tirage, date, bank, group }) =>
  apiRequest(`/tickets/supervisor/sales-monitoring/summary/${toQuery({ tirage, date, bank, group })}`);

export const fetchSupervisorMoveDetail = ({ tirage, date, product, numbers, bank, group }) =>
  apiRequest(`/tickets/supervisor/sales-monitoring/move-detail/${toQuery({ tirage, date, product, numbers, bank, group })}`);

export const fetchSupervisorTicketsPerBank = ({ tirage, date, product, numbers, bank }) =>
  apiRequest(`/tickets/supervisor/sales-monitoring/tickets-per-bank/${toQuery({ tirage, date, product, numbers, bank })}`);

export const fetchSupervisorTicketDetail = (ticketId) =>
  apiRequest(`/tickets/supervisor/sales-monitoring/ticket-detail/${ticketId}/`);

// Pas de champ Banque ici : cote company, "Banques Connecte" n'a jamais eu
// l'option Bank dans son radio de portee (seulement Tout/Groupe/Superviseur) —
// cote superviseur la portee est donc toujours SES banks, avec un `group`
// optionnel (le drill-down par banque individuelle se fait en cliquant une banque).
export const fetchSupervisorBankMonitoring = ({ date, tirage, group }) =>
  apiRequest(`/banks/supervisor/monitoring/${toQuery({ date, tirage, group })}`);

export const searchSupervisorVerifyTickets = ({ bank, group, date, tirageFrom, tirageUp, ticket, searchBy }) =>
  apiRequest(`/tickets/supervisor/verify/search/${toQuery({
    bank, group, date, tirage_from: tirageFrom, tirage_up: tirageUp, ticket, search_by: searchBy,
  })}`);

// ── Central superviseur (2026-09-26) : le reste du Central company, limite a
// SES banks cote backend. Actions en PATCH (permission "Modifier" retirable).
export const fetchSupervisorExpressMonitoring = ({ date, bank, group } = {}) =>
  apiRequest(`/tickets/supervisor/sales-monitoring/express/${toQuery({ date, bank, group })}`);

export const searchSupervisorNullifyTickets = ({ bank, sq, searchBy, date, tirage, no, serial }) =>
  apiRequest(`/tickets/supervisor/nullify/search/${toQuery({ bank, sq, search_by: searchBy, date, tirage, no, serial })}`);

export const supervisorNullifyTicket = (ticketId) =>
  apiRequest(`/tickets/supervisor/nullify/${ticketId}/`, { method: 'PATCH' });

export const searchSupervisorRevertTickets = ({ bank, sq, searchBy, date, tirage, no }) =>
  apiRequest(`/tickets/supervisor/revert/search/${toQuery({ bank, sq, search_by: searchBy, date, tirage, no })}`);

export const supervisorRevertTicket = (ticketId) =>
  apiRequest(`/tickets/supervisor/revert/${ticketId}/`, { method: 'PATCH' });

export const searchSupervisorPayTickets = ({ bank, tirage, no, date }) =>
  apiRequest(`/tickets/supervisor/pay-ticket/search/${toQuery({ bank, tirage, no, date })}`);

export const supervisorPayTicket = (ticketId) =>
  apiRequest(`/tickets/supervisor/pay-ticket/${ticketId}/`, { method: 'PATCH' });

export const setSupervisorBankPassword = (bankId, { password, password_confirm }) =>
  apiRequest(`/banks/supervisor/banks/${bankId}/set-password/`, { method: 'PATCH', body: { password, password_confirm } });
